import React from 'react';

const BarFour = () => {
  return (
    <svg width="80" height="4" viewBox="0 0 80 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="80" height="4" fill="#E6E9EC" />
    </svg>
  );
};

export default BarFour;
